import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import {
  WORK_DAY_FIND,
  WORK_DAY_FIND_SUCCESS,
  WORK_DAY_FAILED,
  DUAL_PRICING_FIND,
 } from '../actions'
import { WorkDayService } from '@core/services';
import { Store } from '@ngrx/store';
import { selectStore } from '../selectors';

@Injectable()
export class WorkDayEffects {
  constructor(
    private actions$: Actions,
    private workDayService: WorkDayService,
    private store: Store,
  ) {}

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WORK_DAY_FIND),
      withLatestFrom(this.store.select(selectStore)),
      filter(([_, store]) => !!store?.idLocal),
      map(([_, store]) => store!.idLocal as string),
      mergeMap((storeId) =>{
        return this.workDayService.getWorkDay(storeId).pipe(
          mergeMap(({ data }) => {
            const [workDay] = data;

            if(!!workDay?.doblePrecioId){
              return [
                WORK_DAY_FIND_SUCCESS({workDay}),
                DUAL_PRICING_FIND({id: workDay.doblePrecioId}),
              ];
            } else {
              return [
                WORK_DAY_FIND_SUCCESS({workDay}),
              ]; 
            }
          }),
          catchError((error) =>
            of(
              WORK_DAY_FAILED({
                error: error.error?.message || 'Error loading local canals',
              })
            )
          )
        )
        }
      )
    )
  );
}
